// Modalità TEST — ambiente di collaudo permanente e protetto.
// Attivazione SOLO esplicita via URL: ?testmode=on (persiste in localStorage).
// Disattivazione: ?testmode=off. In test mode TUTTE le chiamate API puntano
// ESCLUSIVAMENTE a /test-api/api (backend_test :8002, DB isolato) — nessun
// fallback verso /api di produzione.
const FLAG_KEY = "OLIO_TEST_MODE";

function resolveTestMode() {
  try {
    const v = new URLSearchParams(window.location.search).get("testmode");
    if (v === "on") localStorage.setItem(FLAG_KEY, "1");
    else if (v === "off") localStorage.removeItem(FLAG_KEY);
    return localStorage.getItem(FLAG_KEY) === "1";
  } catch {
    return false;
  }
}

export const IS_TEST_MODE = resolveTestMode();

// Chiavi token separate: la sessione test non contamina mai quella di produzione.
export const ACCESS_TOKEN_KEY = IS_TEST_MODE ? "test_access_token" : "access_token";
export const REFRESH_TOKEN_KEY = IS_TEST_MODE ? "test_refresh_token" : "refresh_token";

if (IS_TEST_MODE) {
  document.title = "[TEST] Olio Esausto — DATI NON REALI";
}
